import styled from 'styled-components'
import {Col, Row} from 'antd'
import { device } from '../../styles/devices';

export const TituloMenu = styled.h1`
  font-size: 20px;
  text-align: center;
  letter-spacing:2px;
  color: black;
  margin:0;
  padding:0;
  font-weight:400;
 
  @media ${device.laptop} { 
    font-size: 40px;
  }

  @media ${device.mobileL} { 
    font-size: 25px;
  }
`;

export const ColFlex= styled(Col)`
  display:flex;
  justify-content:center;
  align-items:center;
  box-sizing: border-box;
  margin-top:2em;
`;

export const ColFlexColumn= styled(Col)`
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
  box-sizing: border-box;
  margin-top:2em;
  height:100%;
`;

export const RowStyle= styled(Row)`
   margin: 2em 0 2em 0;
`;

export const DivPedidoContenido = styled.div`
  font-size: 14px;
  letter-spacing:1px;
  color: black;
  font-weight:bold;
`;

export const DivFlexColumn=styled.div`
  display:flex;
  flex-direction:${props => props.column?"column":"row"};
  justify-content:center;
`;

export const SpanSatus = styled.span`
  background: ${props => props.background};
  color: ${props => props.color};
  font-size: 1em;
  margin: 1em;
  padding: 0.25em 1em;
  border-radius: 3px;
`;


export const ImgResponsive = styled.img`
  width:100%
  object-fit: contain;
  border-radius:5px;

  @media ${device.laptop} { 
    width:40%
  }

  @media ${device.mobileL} { 
    width:40%
  }
`;

export const ImageHoverAction=styled.div`
 position: relative;
 width: 80%;
 
 img{
  opacity: 1;
  display: block;
  width: 100%;
  transition: .5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

:hover img {
  opacity: 0.5;
}

:hover .middle {
  opacity: 1;
}

.text {
  background-color: #4CAF50;
  color: white;
  font-size: 16px;
  padding: 16px 32px;
}


@media ${device.laptop} { 
  width: 50%;
}

@media ${device.mobileL} { 
  width: 50%;
}
`;

export const DivDetail=styled.div`
padding:.5em;
font-weight:400;
letter-spacing:1.5px
span{
  color:#112d4e;
  font-weight:bold;
}

@media ${device.laptop} { 

}

@media ${device.mobileL} { 
 
}
`;


export const DivResponsive=styled.div`
.tableOrden{
  display:none;
}
.listOrden{
  display:block;
}

@media ${device.laptop} { 
  .tableOrden{
    display:block;
  }
  .listOrden{
    display:none;
  }

}


`;
